"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MagicForm = exports.Validation = void 0;
const yup_1 = require("yup");
class Validation {
    static registerForm(target, paths) {
        const name = this.nameFromTarget(target);
        this.formMap.set(name, paths);
    }
    static getFormPath(target, field, editId) {
        var _a;
        const name = this.nameFromTarget(target);
        const pathBase = (_a = this.formMap.get(name)[field]) !== null && _a !== void 0 ? _a : '';
        const fullBasePath = this.fixSlashInEndOfPath(pathBase) + (editId !== undefined ? editId : '');
        return fullBasePath;
    }
    static fixSlashInEndOfPath(pathBase) {
        const lastChar = pathBase[pathBase.length - 1];
        return lastChar === '/' ? pathBase : pathBase + '/';
    }
    static registerCustomValidation(target, propertyKey, customValidator) {
        let { index, targetParams } = this.getTargetParamsAndIndex(target, propertyKey);
        if (index === -1) {
            const name = propertyKey;
            targetParams.push(this.emptyValidParam({ name, customValidator }));
        }
        else {
            targetParams[index].customValidator = customValidator;
        }
    }
    static registerTypeValidation(target, propertyKey, type) {
        let { index, targetParams } = this.getTargetParamsAndIndex(target, propertyKey);
        if (index === -1) {
            targetParams.push(this.emptyValidParam({ name: propertyKey, type }));
        }
        else {
            const params = targetParams[index];
            params.type = type;
        }
    }
    static registerValidation(target, propertyKey, validator, type) {
        let { index, targetParams } = this.getTargetParamsAndIndex(target, propertyKey);
        if (index === -1) {
            const name = propertyKey;
            targetParams.push(this.emptyValidParam({ name, type }));
            index = targetParams.length - 1;
        }
        const params = targetParams[index];
        params.validators.push(validator);
        if (type) {
            params.type = type;
        }
    }
    static getTargetParamsAndIndex(target, propertyKey) {
        const targetParams = this.getKeys(target);
        const index = targetParams.findIndex(({ name }) => name === propertyKey);
        return { targetParams, index };
    }
    static emptyValidParam(validatorParams) {
        return Object.assign({ validators: [] }, validatorParams);
    }
    static prepareValidator(validators, type) {
        return validators.reduce((res, { validationFunction, args }) => res[validationFunction](...args), type !== null && type !== void 0 ? type : yup_1.string());
    }
    static getKeys(target) {
        const name = this.nameFromTargetConstructor(target);
        let keys = this.schemaMap.get(name);
        if (!keys) {
            keys = [];
            this.schemaMap.set(name, keys);
        }
        return keys;
    }
    static getSchema(target) {
        const name = this.nameFromTarget(target);
        let schemaProps = this.schemaMap.get(name);
        if (!schemaProps) {
            return undefined;
        }
        return yup_1.object().shape(schemaProps.reduce((res, { name, type, validators }) => {
            return (Object.assign(Object.assign({}, res), { [name]: this.prepareValidator(validators, type) }));
        }, {}));
    }
    static getAll() {
        return { schema: this.schemaMap, forms: this.formMap };
    }
    static nameFromTargetConstructor(target) {
        let partsOfString = `${target.constructor}`.split(/['|"]/);
        return partsOfString[1];
    }
    static nameFromTarget(target) {
        let partsOfString = `${target}`.split(/['|"]/);
        return partsOfString[1];
    }
}
exports.Validation = Validation;
Validation.schemaMap = new Map();
Validation.formMap = new Map();
class MagicForm {
    constructor(target) {
        this.schema = Validation.getSchema(target);
        this.postPath = Validation.getFormPath(target, 'post');
        this.editPath = Validation.getFormPath(target, 'edit');
    }
}
exports.MagicForm = MagicForm;
//# sourceMappingURL=validator.js.map